import React, { useMemo } from "react";
import {
  Image,
} from '@lockerpm/design';

import images from "../../assets/images";

const CreditCard = (props) => {
  const {
    className = '',
    card = {},
  } = props;

  const cardType = useMemo(() => {
    return card.card_type?.toLowerCase()
  }, [card])

  const cardTypeText = useMemo(() => {
    switch (cardType) {
      case 'visa':
        return 'Visa';
      case 'mastercard':
        return 'MasterCard';
      case 'amex':
        return 'American Express';
      case 'discover':
        return 'Discover';
      case 'jcb':
        return 'JCB';
      default:
        return card.card_type;
    }
  }, [card, cardType])

  return (
      <div className={`flex items-center ${className}`}>
      <div
        className="bg-[#f5f8fa] w-10 h-10 rounded flex items-center justify-center p-1 mr-4"
      >
        {
          cardType === 'visa' && <Image src={images.VisaImage} preview={false}/>
        }
        {
          cardType === 'mastercard' && <Image src={images.MasterImage} preview={false}/>
        }
        {
          cardType === 'amex' && <Image src={images.AmexImage} preview={false}/>
        }
        {
          cardType === 'discover' && <Image src={images.DiscoverImage} preview={false}/>
        }
        {
          cardType === 'jcb' && <Image src={images.JCBImage} preview={false}/>
        }
        {
          ![
            'visa',
            'mastercard',
            'amex',
            'discover',
            'jcb'
          ].includes(cardType) && <Image src={CardImage} preview={false}/>
        }
      </div>
      <div>
        <div className="text-black font-bold mb-2 ">
          {cardTypeText}
        </div>
        <div className="flex items-center justify-between">
          <div className="text-black-500 mr-10">
            {card.expire}
          </div>
          <div className="text-black-500 flex items-center">
            <span
              className="bg-black-500 w-[4px] h-[4px] rounded-full mr-0.5"
            />
            <span
              className="bg-black-500 w-[4px] h-[4px] rounded-full mr-0.5"
            />
            <span
              className="bg-black-500 w-[4px] h-[4px] rounded-full mr-0.5"
            />
            <span
              className="bg-black-500 w-[4px] h-[4px] rounded-full mr-0.5"
            />
            <span>{card.last4}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditCard;